import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2e0c7478"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-inner-container" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ImageCarosel = _resolveComponent("ImageCarosel");
    const _component_FriedGetAcceptLogoSmall = _resolveComponent("FriedGetAcceptLogoSmall");
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['container', { 'form-only': _ctx.hideImage }])
    }, [
        (!_ctx.hideImage)
            ? (_openBlock(), _createBlock(_component_ImageCarosel, {
                key: 0,
                class: "hidden-xs-and-down"
            }))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_FriedGetAcceptLogoSmall, { class: "logo" }),
                _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ])
        ])
    ], 2));
}
